<template>
  <div>
    <span>{{label}}</span>
    <div class="spacer--s" />
    <div class="star-container">
      <img
        v-for="(val, i) in 5"
        :key="i"
        :src="i < value ? starFilled : starOutlined"
        style="cursor: pointer;"
        @click="$emit('input', val)"
      />
<!--      <svg>-->
<!--        <use xlink:href="~@/assets/icons/star-mdi.svg"></use>-->
<!--      </svg>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Rating",
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    starOutlined(){
      return require('@/assets/icons/star-mdi.svg')
    },
    starFilled(){
      return require('@/assets/icons/star-mdi-filled.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
.star-container{
  display: flex;
  justify-content: space-between;
  width: 120px;
  margin-bottom: 16px;

  img{
    svg{
      fill: yellow;
    }
  }
}
</style>
